import {connection} from './connection';
import {post} from './posts';
import {category, categories} from './categories';
import {users} from './users';
import {maps} from './maps';
import {map_search} from './map_search';
import {client} from './client';
import {clients} from './clients';
import {account} from './account';
import {tasks} from './tasks';
import {liveWeatherCenter} from './live_weather_center';
import {roleManagement} from './roleManagement';
import {socket} from './socket';
import {client_incidents} from './client_incidents';
export {fields} from './fields';
import {plans} from './plans';
import {features} from './features';
import mapCreator from './mapCreator';
import subscriptions from './subscriptions';


/** The core global state of our application.
* @namespace Reducers
*
*/

export * from './contacts';
export * from './jobs';
export * from './ui';
export * from './pipeline';
export * from './canvassing';
export * from './notifications';
export * from './integrations';
export * from './sales-site-manager';
export {
	connection,
	post,
	users,
	categories,
	maps, //TODO: Transition the map creation to a state similar to map_search. Handle the state's differently? Or potentially make "Create" a separate mode for the same map. (Renaming the map_search to something more general may be necessary.)
	map_search, //New way of handling the state for search_maps component.
  client_incidents,
	clients,
	client,
	account,
	tasks,
	liveWeatherCenter,
	roleManagement,
  socket,
  plans,
  features,
	mapCreator,
	subscriptions
};



// WEBPACK FOOTER //
// ./src/common/reducers/index.js